import { AllPeriodsLimitType, LimiteGeralModel, LimiteTipoPeriodo, LimitIdentifierType, LimitPeriodType, LimitTipo } from "../master/limits/models/limits";

export default class LimitUtil {
  static splitLimitTypeAndPeriod(limitType: LimiteTipoPeriodo): LimitIdentifierType {
    const splitLimitType = limitType.split('_');
    const limitPeriod = splitLimitType[splitLimitType.length - 1] as LimitPeriodType;
    const limitTypeWithoutPeriod = limitType.replace(/_(DIURNO|NOTURNO)$/g, '');

    return {
      limitType: limitTypeWithoutPeriod as LimitTipo,
      limitPeriod,
    };
  }

  static getLimitByTypeAndPeriod(
    limits: LimiteGeralModel[],
    limitType: LimitTipo,
    limitPeriod: LimitPeriodType,
  ) {
    return limits.find(limit => {
      const { limitType: currentLimitType, limitPeriod: currentLimitPeriod } = LimitUtil.splitLimitTypeAndPeriod(limit.Tipo);
      return currentLimitType === limitType && currentLimitPeriod === limitPeriod;
    })
  }

  static groupLimitsByPeriod(limits: LimiteGeralModel[]) {
    const mappedLimits: AllPeriodsLimitType[] = [];
    limits.forEach((limit: LimiteGeralModel) => {
      const { limitType } = LimitUtil.splitLimitTypeAndPeriod(limit.Tipo);
      const currentLimitIndex = mappedLimits.findIndex(
        currentLimit => currentLimit.dailyLimit.Tipo.includes(limitType),
      );
      const isDailyLimitAlreadyMapped = currentLimitIndex >= 0;
      if (isDailyLimitAlreadyMapped) {
        mappedLimits[currentLimitIndex].nightlyLimit = limit;
        return;
      }
      const mappedLimit = {
        type: limitType,
        dailyLimit: LimitUtil.getLimitByTypeAndPeriod(limits, limitType, 'DIURNO')!,
        nightlyLimit: LimitUtil.getLimitByTypeAndPeriod(limits, limitType, 'NOTURNO'),
      };
      mappedLimits.push(mappedLimit);
    });
    return mappedLimits;
  }
}


// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/utils/limit-utils.ts